import ImageLeftTextRight from './ImageLeftTextRight.js';

export default ImageLeftTextRight;